import styled from 'styled-components';
import { color } from '~/assets/styles/colors';
import { NavLink, NavItem } from 'reactstrap';

export const TabsNavigation = styled.div`
	border-bottom: 2px solid ${color.primary};
	margin-bottom: 30px;
`;

export const NavLinkStyled = styled(NavLink)`
	background-color: ${(props) =>
		props.active ? color.primary : '#f1f1f1'} !important;
	color: ${(props) => (props.active ? 'black' : '#999999')} !important;
	padding: 10px 70px !important;
	border-radius: 10px 10px 0px 0px !important;
	margin-right: 10px !important;
	font-size: 18px !important;
	margin-bottom: 0 !important;
	cursor: pointer !important;

	&:hover {
		background-color: #8dfdc1 !important;
		color: white !important;
	}

	&:before {
		border: 0 !important;
	}

	&:after {
		border: 0 !important;
	}
`;

export const NavItemStyled = styled(NavItem)`
	text-align: center;

	@media (max-width: 768px) {
		width: 100%;
		.nav-link {
			width: 100%;
		}
	}
`;

export const ButtonStyle = styled.button`
	background-color: ${color.white};
	color: ${color.yellow};
	padding: 15px;
	height: 100%;
	width: 20%;
	border: 2px solid ${color.yellow};
	border-radius: 50px;
`;

export const ButtonStyleOk = styled.button`
	background-color: ${color.primary};
	color: ${color.black};
	padding: 15px;
	height: 100%;
	width: 10%;
	border: 0;
	border-radius: 50px;
`;
